import { render } from "./drivers-page.vue?vue&type=template&id=3352ba97&scoped=true"
import script from "./drivers-page.vue?vue&type=script&lang=js"
export * from "./drivers-page.vue?vue&type=script&lang=js"

import "./drivers-page.vue?vue&type=style&index=0&id=3352ba97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3352ba97"]])

export default __exports__